import {
  AddCameraIcon,
  BroadcastIcon,
  SplitViewIcon,
} from '@hakimo-ui/hakimo/ui-elements';
import { Button, ItemsSwitch, SwitchItem } from '@hakimo-ui/shared/ui-base';
import { FilmIcon } from '@heroicons/react/24/solid';
import clsx from 'clsx';
import { useState } from 'react';
import { CameraFeedMode } from '../types';
import { useAlarmGroupTracking } from '../useAlarmGroupTracking';
import AddCameraFromTenantModal from './AddCameraFromTenantModal';

interface Props {
  mode: CameraFeedMode;
  onChangeMode: (mode: CameraFeedMode) => void;
  locationName: string;
}

export function HeaderActions(props: Props) {
  const { mode, onChangeMode, locationName } = props;
  const track = useAlarmGroupTracking();
  const [showAddCameraModal, setShowAddCameraModal] = useState(false);

  const switchOptions = [
    {
      id: CameraFeedMode.ALARM_VIDEO,
      name: '',
      icon: FilmIcon,
      title: 'Alarms',
    },
    {
      id: CameraFeedMode.LIVE,
      name: '',
      icon: () => (
        <BroadcastIcon
          className={clsx(
            'rounded-lg fill-white',
            mode === CameraFeedMode.LIVE
              ? 'animate-pulse bg-red-500'
              : 'bg-gray-500'
          )}
        />
      ),
      title: 'Live',
    },
    {
      id: CameraFeedMode.SPLIT,
      name: '',
      icon: () => (
        <SplitViewIcon className="dark:stroke-ondark-text-1 stroke-onlight-text-2 h-4 w-4 flex-shrink-0" />
      ),
      title: 'Split View',
    },
  ];

  const onChangeItemsSwitch = (item: SwitchItem) => {
    track('alarm_group_change_cam_mode', { mode: item.id });
    onChangeMode(item.id as CameraFeedMode);
  };

  const onAddCameraFromTenant = () => {
    track('alarm_group_add_camera');
    setShowAddCameraModal(true);
  };
  const handleModalClose = () => setShowAddCameraModal(false);

  return (
    <div className="flex items-center gap-1">
      {mode === CameraFeedMode.LIVE && (
        <Button variant="icon" onClick={onAddCameraFromTenant}>
          <div className="flex items-center gap-1">
            <AddCameraIcon className="h-5 w-5" />
            <div className="flex flex-col items-center text-xs">
              <span>Add</span>
              <span>Camera</span>
            </div>
          </div>
        </Button>
      )}

      <div className="border-onlight-line-2 dark:border-ondark-line-2 rounded-md border p-[2px]">
        <ItemsSwitch
          items={switchOptions}
          onChange={onChangeItemsSwitch}
          selectedItem={switchOptions.find((opt) => opt.id === mode)}
          orientation="horizontal"
          size="small"
        />
      </div>
      {showAddCameraModal && (
        <AddCameraFromTenantModal
          locationName={locationName}
          onClose={handleModalClose}
        />
      )}
    </div>
  );
}

export default HeaderActions;
